import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit';
import * as endpoints from '../networkUtility/endpoints';
import * as localStorageActiontype from '../LocalStorage/ActionTypes';
import {getLocalStorage} from '../LocalStorage/GetLocalStorage';

import {toggleNotificationVisibility} from './networkNotification';
import {NotificationType} from '../Utility/InterFacesAndEnum';
import {toggleLoader} from './loader'
import {handle401Status} from '../Utility/Utility';


const promotionInitialState = {
    isLoading:false,
    home:[],
    lottery:[],
    auction:[],
    desktopImagUrl:"",
    desktopFileName:"",
    mobileImgUrl:"",
    mobileFileName:"",
    desktopSlideImagUrl:"",
    desktopSlideFileName:"",
    mobileSlideImgUrl:"",
    mobileSlideFileName:"",
    homeBannerRedirectionUrl:"https://www.google.com",

    additionalDesktopImagUrl:"",
    additionalDesktopFileName:"",
    additionalMobileImgUrl:"",
    additionalMobileFileName:"",
}

interface ImageObj {
    documentName: string
    fileDownloadUri: string
    fileId: string
    fileName: string
    fileSize: number
    fileType: string
    }

interface SetImgDetails {
    fileName:string,
    imgUrl:string
}

export const getPromotionList = createAsyncThunk(
    'get promotion list',
    async(payload:string,{dispatch}) => {
        dispatch(toggleLoader({
            isLoading: true
        }));
        await fetch(`${endpoints.getPromotionList}?promotionPage=${payload}`,{
            method: 'GET',
            headers: {
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            }
        })
        .then((response) => {
            return response.json()
        })
        .then((response) => {

            if (response.statusCode === 401) {
                handle401Status();
            }

           if (response.statusCode === 200) {
               dispatch(setDesktopBanners({
                   response:response.result,
                   responseType:payload
               }))
            dispatch(toggleNotificationVisibility({
                isVisible:false,
                status: NotificationType.success,
                message: response.errorMsg
            }));
           } else {
            dispatch(toggleNotificationVisibility({
                isVisible: true,
                status: NotificationType.error,
                message: response.errorMsg
            }));
           }
        })
        .catch(() => {
            dispatch(toggleNotificationVisibility({
                isVisible: true,
                status: NotificationType.error,
                message: "Something went wrong"
            }));
        })
        .finally(() => {
            dispatch(toggleLoader({
                isLoading: false
            }));
        });
    }
);

export const uploadPromotionImages = createAsyncThunk(
    'upload image',
    async (payload:any, {dispatch}) => {
        dispatch(toggleLoader({
            isLoading: true
        }));
        await fetch(endpoints.uploadImage,{
            method: "POST",
            headers:{
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
            },
            body:payload.formObj
        })
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            let image:ImageObj = response
                    let imageUrl = image.fileDownloadUri;
                    let fileName = image.fileName;
                    // console.log(payload.id,"payloadId")
                    if (payload.isForDesktop){
                        dispatch(setDesktopImgDetails(
                            {
                                fileName:fileName,
                                imgUrl:imageUrl
                            }
                        ))
                    } else {
                        dispatch(setMobileImgDetails(
                            {
                                fileName:fileName,
                                imgUrl:imageUrl
                            }
                        ))
                    }
        })
        .catch(() => {
            dispatch(toggleNotificationVisibility({
                isVisible: true,
                status: NotificationType.error,
                message: "something went wrong!"
            }));
        })
        .finally(() => {
            dispatch(toggleLoader({
                isLoading: false
            }));
        })
    }
);

export const uploadAdditionalPromotionImages = createAsyncThunk(
    'upload image',
    async (payload:any, {dispatch}) => {
        dispatch(toggleLoader({
            isLoading: true
        }));
        await fetch(endpoints.uploadImage,{
            method: "POST",
            headers:{
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
            },
            body:payload.formObj
        })
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            let image:ImageObj = response
                    let imageUrl = image.fileDownloadUri;
                    let fileName = image.fileName;
                    // console.log(payload.id,"payloadId")
                    if (payload.isForDesktop){
                        dispatch(setAdditionalDesktopImgDetails(
                            {
                                fileName:fileName,
                                imgUrl:imageUrl
                            }
                        ))
                    } else {
                        dispatch(setAdditionalMobileImgDetails(
                            {
                                fileName:fileName,
                                imgUrl:imageUrl
                            }
                        ))
                    }
        })
        .catch(() => {
            dispatch(toggleNotificationVisibility({
                isVisible: true,
                status: NotificationType.error,
                message: "something went wrong!"
            }));
        })
        .finally(() => {
            dispatch(toggleLoader({
                isLoading: false
            }));
        })
    }
);
  
export const uploadSliderPromotionImages = createAsyncThunk(
    'upload image',
    async (payload:any, {dispatch}) => {
        dispatch(toggleLoader({
            isLoading: true
        }));
        await fetch(endpoints.uploadImage,{
            method: "POST",
            headers:{
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
            },
            body:payload.formObj
        })
        .then((response) => {
            return response.json();
        })
        .then((response) => {
            let image:ImageObj = response
                    let imageUrl = image.fileDownloadUri;
                    let fileName = image.fileName;
                    // console.log(payload.id,"payloadId")
                    if (payload.isForDesktop){
                        dispatch(setDesktopSliderImgDetails(
                            {
                                fileName:fileName,
                                imgUrl:imageUrl
                            }
                        ))
                    } else {
                        dispatch(setMobileSliderImgDetails(
                            {
                                fileName:fileName,
                                imgUrl:imageUrl
                            }
                        ))
                    }
        })
        .catch(() => {
            dispatch(toggleNotificationVisibility({
                isVisible: true,
                status: NotificationType.error,
                message: "something went wrong!"
            }));
        })
        .finally(() => {
            dispatch(toggleLoader({
                isLoading: false
            }));
        })
    }
);


export const updatePromotion = createAsyncThunk(
    'update promotion section',
    async (payload:any, {dispatch}) => {
        // console.log(payload.promotionPage)
        dispatch(toggleLoader({
            isLoading: true
        }));
        await fetch(endpoints.updatePromotionSection,{
            method: 'PUT',
            headers:{
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            },
            body:JSON.stringify(payload)
        })
        .then((response) => {
            return response.json()
        })
        .then((response) =>{
           if(response.statusCode===200){
            dispatch(toggleNotificationVisibility({
                isVisible:true,
                status:NotificationType.success,
                message:response.errorMsg
            }))
            dispatch(getPromotionList(payload.promotionPage))
           }
            if (response.statusCode === 401) {
                handle401Status();
            }

        })
        .finally(() => {
            dispatch(toggleLoader({
                isLoading: false
            }));
        })
    }
)


export const createPromotion = createAsyncThunk(
    'update promotion section',
    async (payload:any, {dispatch}) => {
        dispatch(toggleLoader({
            isLoading: true
        }));
        await fetch(endpoints.createPromotionSection,{
            method: 'POST',
            headers:{
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            },
            body:JSON.stringify(payload)
        })
        .then((response) => {
            return response.json()
        })
        .then((response) =>{
           if(response.statusCode===200){
            dispatch(toggleNotificationVisibility({
                isVisible:true,
                status:NotificationType.success,
                message:response.errorMsg
            }))
           }
            if (response.statusCode === 401) {
                handle401Status();
            }

        })
        .finally(() => {
            dispatch(toggleLoader({
                isLoading: false
            }));
        })
    }
)


export const deletePromotionById = createAsyncThunk(
    'delete promotion by id',
    async(payload:any,{dispatch})=>{
        dispatch(toggleLoader({isLoading:true}))

        console.log(payload)
        await fetch(`${endpoints.deletePromotion}${payload}`,{
            method:"DELETE",
            headers:{
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            },
        }).then((response)=>{
            return response.json();
        }).then((data)=>{
            console.log(data)
        }).catch((err)=>{
            dispatch(toggleLoader({isLoading:false}))
            return err;
        }).finally(()=>{
            dispatch(toggleLoader({isLoading:false}))
        })
    }
)

export const disableEnablePromotionById = createAsyncThunk(
    'desable enable promotion by id',
    async(payload:any,{dispatch})=>{
        dispatch(toggleLoader({isLoading:true}))

        console.log(payload)
        await fetch(`${endpoints.disableEnablePromotion}${payload?.promotionId}`,{
            method:"PUT",
            headers:{
                Authorization: `Bearer ${getLocalStorage(localStorageActiontype.GET_ACCESS_TOKEN)}`,
                "Content-type": "application/json; charset=UTF-8",
            },
        }).then((response)=>{
            return response.json();
        }).then((data)=>{
            console.log(data)
            if(data?.statusCode===200){
                dispatch(toggleNotificationVisibility({
                    isVisible:true,
                    status:NotificationType.success,
                    message:data.errorMsg
                }))
                dispatch(getPromotionList(payload?.promotionPage))
            }else{
                dispatch(toggleNotificationVisibility({
                    isVisible:true,
                    status:NotificationType.error,
                    message:data.errorMsg
                }))
            }
        }).catch((err)=>{
            dispatch(toggleLoader({isLoading:false}))
            return err;
        }).finally(()=>{
            dispatch(toggleLoader({isLoading:false}))
        })
    }
)

const promotionReducer = createSlice({
    name:'Promotion reducer',
    initialState:promotionInitialState,
    reducers:{
        setDesktopBanners: (state, action:PayloadAction<{
            responseType:string,
            response:any
        }>) => {
            if (action.payload.responseType === "HOME") {
                return {
                    ...state,
                    home:action.payload.response
                }
            } else if (action.payload.responseType === "LOTTERY") {
                return {
                    ...state,
                    lottery:action.payload.response
                }
            } else if (action.payload.responseType === "AUCTION"){
                return{
                    ...state,
                    auction:action.payload.response
                }
            }
        },
        setDesktopImgDetails:(state, action:PayloadAction<SetImgDetails>) => {
            return {
                ...state,
                desktopImagUrl:action.payload.imgUrl,
                desktopFileName:action.payload.fileName
            }
        },
        setMobileImgDetails:(state, action:PayloadAction<SetImgDetails>) => {
            return {
                ...state,
                mobileImgUrl: action.payload.imgUrl,
                mobileFileName:action.payload.fileName
            }
        },
        setAdditionalMobileImgDetails:(state, action:PayloadAction<SetImgDetails>) => {
            return {
                ...state,
                additionalMobileImgUrl: action.payload.imgUrl,
                additionalMobileFileName:action.payload.fileName
            }
        },
        setAdditionalDesktopImgDetails:(state, action:PayloadAction<SetImgDetails>) => {
            return {
                ...state,
                additionalDesktopImagUrl:action.payload.imgUrl,
                additionalDesktopFileName:action.payload.fileName
            }
        },
        setDesktopSliderImgDetails:(state, action:PayloadAction<SetImgDetails>) => {
            return {
                ...state,
                desktopSlideImagUrl:action.payload.imgUrl,
                desktopSlideFileName:action.payload.fileName
            }
        },
        setMobileSliderImgDetails:(state, action:PayloadAction<SetImgDetails>) => {
            return {
                ...state,
                mobileSlideImgUrl: action.payload.imgUrl,
                mobileSlideFileName:action.payload.fileName
            }
        },
        resetPromotion:(state) => {
            return{
                ...state,
            }
        }
    }
})

export const {setDesktopBanners,setDesktopImgDetails,setMobileImgDetails,setDesktopSliderImgDetails,setAdditionalDesktopImgDetails,setAdditionalMobileImgDetails,setMobileSliderImgDetails} = promotionReducer.actions;
export default promotionReducer.reducer;